import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  portal_url: process.env.REACT_APP_PORTAL_URL || "",
  booking_url: "",
  google_review_url: "",
  business_email: "INFO@DATAXGUY.COM",
  business_phone: "201-253-7674",
  facebook_url: "",
  instagram_url: "",
  linkedin_url: "",
  twitter_url: "",
};

const SettingsContext = createContext(DEFAULTS);

export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((res) => setSettings({ ...DEFAULTS, ...res.data }))
      .catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}
